export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3 text-center">
          Sugargoo vs Other Shopping Agents
        </h2>
        <p className="text-sm text-foreground-600 text-center max-w-lg mx-auto mb-10">
          See how Sugargoo compares to other popular shopping agent platforms
        </p>
        <div className="max-w-3xl mx-auto bg-background-50 rounded-2xl overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200">
                <th className="text-left px-6 py-4 font-semibold text-foreground-950">Platform</th>
                <th className="text-left px-6 py-4 font-semibold text-foreground-950">Fees</th>
                <th className="text-left px-6 py-4 font-semibold text-foreground-950">Speed</th>
                <th className="text-left px-6 py-4 font-semibold text-foreground-950">Ease of Use</th>
                <th className="text-left px-6 py-4 font-semibold text-foreground-950">Rating</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-100">
                <td className="px-6 py-4 font-semibold text-foreground-950">Sugargoo</td>
                <td className="px-6 py-4 text-primary-600 font-medium">Low</td>
                <td className="px-6 py-4 text-foreground-600">Fast</td>
                <td className="px-6 py-4 text-foreground-600">Easy</td>
                <td className="px-6 py-4 text-accent-600 font-semibold whitespace-nowrap">★★★★★</td>
              </tr>
              <tr className="border-b border-background-100">
                <td className="px-6 py-4 font-semibold text-foreground-950">Pandabuy</td>
                <td className="px-6 py-4 text-foreground-700">Medium</td>
                <td className="px-6 py-4 text-foreground-600">Fast</td>
                <td className="px-6 py-4 text-foreground-600">Medium</td>
                <td className="px-6 py-4 text-foreground-700 whitespace-nowrap">★★★★☆</td>
              </tr>
              <tr>
                <td className="px-6 py-4 font-semibold text-foreground-950">CSSBuy</td>
                <td className="px-6 py-4 text-foreground-700">Low</td>
                <td className="px-6 py-4 text-foreground-600">Slow</td>
                <td className="px-6 py-4 text-foreground-600">Hard</td>
                <td className="px-6 py-4 text-foreground-700 whitespace-nowrap">★★★☆☆</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}